import { Enum } from '~/data/enums';

export enum CustomFieldTypes {
  DATE = 'DATE',
  TEXT = 'TEXT',
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  MULTISELECT = 'MULTISELECT',
}

export interface CustomField {
  groupName: string;
  code: string;
  description: string;
  name: string;
  label: string;
  inputType: {
    label: string;
    value: CustomFieldTypes;
  };
  countries?: Array<{
    label: string;
    value: string;
  }>;
  value: string | string[];
}
export type CustomFieldValues = {
  [key: string]: string | string[];
};

export type ReadCustomField = {
  name: string;
  info: string;
  value: string;
  type: string;
};

export type InputProps = {
  validationRules?: object;
  type?: string;
  style?: object;
  id?: string;
  settings?: object;
  name: string;
  defaultValue?: string | string[];
  options?: Enum[];
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
};
export type EditCustomField = {
  name: string;
  info: string;
  inputProps: InputProps;
  type: string;
  editableByEmp?: boolean;
};

export type FieldAttributes = {
  fCustomDataEntity: string;
  fCustomDataAttributeName: string;
  fCustomDataAttributeLabel: string;
  fCustomDataAttributeDataType: string;
  fCustomDataCreatedTime: string;
  fCustomDataCreatedUserId: number;
  fCustomDataUpdatedTime: string;
  fCustomDataUpdatedUserId?: number;
  fCustomDataAttributeCountry?: string[];
  fCustomDataAttributeDataSubtype?: string;
};

export type FieldLang = {
  code: string;
  description: string;
  name: string;
  seq: number;
};

export type AnswerPreProcess = {
  [key: string]: string | string[];
};

export type FieldAttributesHash = {
  [key: string]: FieldAttributes;
};
